import useRequest from '@space-shell/common/hooks/useRequest'
import { SectionService, SectionsEndpoints } from '@space-shell/common/services/sections'
import { useMembershipStore } from '@space-shell/core/store'

export type UseGetProductDetailsProps = {
  productId: string
  enabled?: boolean
}

const useGetProductDetails = ({ productId, enabled = true }: UseGetProductDetailsProps) => {
  const { membershipSlug } = useMembershipStore()

  return useRequest(
    [SectionsEndpoints.sectionProductDetail(String(membershipSlug), productId)],
    () => SectionService.getSectionProductDetail(String(membershipSlug), productId),
    {
      enabled
    }
  )
}

export default useGetProductDetails
